import { IPublicTypeContainerSchema } from './';

/**
 * 低代码业务组件容器
 * @see https://lowcode-engine.cn/lowcode
 */

export interface IPublicTypeComponentSchema extends IPublicTypeContainerSchema {
  componentName: 'Component';
}
